import gql from 'graphql-tag';

export const MemberFields = gql`
  fragment MemberFields on OdProtosDirectoryData_Member {
    uuid
    user {
      token
      fullName
    }
  }
`;
